import React from 'react';

import InputContainer from '../InputContainer/input-container';

export default class EmailInput extends React.PureComponent {
	render() {
		return (
			<InputContainer
				validationError={this.props.validationError}
				id={this.props.id}
				label={this.props.label}
				labelAfterInput={this.props.labelAfterInput}
				body={
					<input
						name={this.props.name}
						placeholder={this.props.placeholder}
						type="email"
						id={this.props.id}
						value={this.props.value || ''}
						required
						onChange={this.props.onChange}
						onBlur={this.props.onBlur}
						className={`form-control ${this.props.validationError ? 'error' : ''}`}
					/>
				}
			/>
		);
	}
}
